import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { PanAppState } from '@panamax/app-state';
import { of } from 'rxjs';
import { withLatestFrom, switchMap, filter, map } from 'rxjs/operators';
import { ORDER_ANALYTICS_ACTIONS } from './order-analytics.actions';
import { ORDER_ACTIONS } from '@order/actions/order-actions';
import { printOrderAnalytics } from './factories/print-order-analytics.factory';
import { PATHS } from '@shared/constants/paths';

@Injectable({
  providedIn: 'root',
})
export class OrderAnalyticsEffects {
  printSubmittedOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ORDER_ACTIONS.printSubmittedOrder),
      withLatestFrom(this.panAppState.currentUrl$),
      filter(([payload, currentUrl]) => !!payload?.orders?.length),
      switchMap(([payload, currentUrl]) => {
        const order = payload.orders[0];
        let origOrderId = order.orderHeader?.origOrderId;
        if (currentUrl.includes(PATHS.ORDER_SUBMITTED)) {
          origOrderId = null;
        }
        const tracking = printOrderAnalytics(
          order.orderHeader?.orderId,
          origOrderId,
          payload.orders.length,
        );
        return of(
          ORDER_ANALYTICS_ACTIONS.trackPrintSubmittedOrder({
            tracking,
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private panAppState: PanAppState,
  ) {}
}
